import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import DigitalEngagementInfo from './digitalEngagementInfo';
import CityBreakdown from './cityBreakdown';
import SearchUsingFilter from './searchUsingFilter';
import PowerBi from './PowerBi';
import NPITable from './npiTable';
import { useDispatch, useSelector } from 'react-redux';
import AgeEngagement from './ageEngagement';
import GenderEngagement from './genderEngagement';
import DeviceEngagement from './deviceEngagement';
import {
    getEngagementRateDataFalse,
    getWebMatrixCostDataFalse,
    getWebMatrixPatientCount,
    getWebMatrixPatientFalse,
} from '../../../redux/thunks/webMatrixThunks';
import CostChart from './costconversionctr/costChart';
import ConversionChart from './costconversionctr/conversionChart';
import CtrChart from './costconversionctr/ctrChart';
import EngagementChannel from './physicianEngagement/engagementChannel';
import WebMetricsInfo from './webMetricsInfo';
import { actions as webMatrixActions } from '../../../redux/reducers/webMatrixReducer';
import DtcTopCityChart from './dtcTopCharts/dtcTopCityChart ';
import DtcTopChannelChart from './dtcTopCharts/dtcTopChannelChart';

const componentConfig = {
    165: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: true,
            genderEngagement: true,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: true,
            dtcTopChannelChart: true,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },

        charts: {
            left: <EngagementChannel />,
            right: <CtrChart />,
        },
        hideAdditionalCtrChart: true,
    },
    61: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: true,
            genderEngagement: true,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <EngagementChannel />,
            right: <CtrChart />,
        },
        hideAdditionalCtrChart: true,
    },

    94: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: false,
            genderEngagement: false,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <EngagementChannel />,
            right: <CtrChart />,
        },
        hideAdditionalCtrChart: true,
    },
    104: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: false,
            genderEngagement: false,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <CostChart />,
            right: <ConversionChart />,
        },
        hideAdditionalCtrChart: false,
    },
    105: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: false,
            genderEngagement: false,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <CostChart />,
            right: <ConversionChart />,
        },
        hideAdditionalCtrChart: false,
    },
    110: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: false,
            genderEngagement: false,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <CostChart />,
            right: <ConversionChart />,
        },
        hideAdditionalCtrChart: false,
    },
    118: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: false,
            genderEngagement: false,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: false,
            dtcTopChannelChart: false,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <CostChart />,
            right: <ConversionChart />,
        },
        hideAdditionalCtrChart: false,
    },
    default: {
        showComponents: {
            digitalEngagementInfo: true,
            webMetricsInfo: true,
            engagementSegments: true,
            deviceEngagement: true,
            ageEngagement: true,
            genderEngagement: true,
            engagementChannel: true,
            ctrChart: true,
            costChart: false,
            cityBreakdown: true,
            dtcTopCityChart: true,
            dtcTopChannelChart: true,
            powerBi: true,
            searchUsingFilter: false, // this will be true after api fix
            npiTable: true,
        },
        charts: {
            left: <CostChart />,
            right: <ConversionChart />,
        },
        hideAdditionalCtrChart: false,
    },
};

const PaidMediaEngagement = () => {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector(
        (state) => state.filter,
    );
    const { resetToInitialState } = webMatrixActions;

    const getConfig = (companyId) =>
        componentConfig[companyId] || componentConfig.default;
    const config = getConfig(company.id);

    useEffect(() => {
        dispatch(resetToInitialState());
        if (company.id) {
            dispatch(
                getWebMatrixPatientFalse({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                }),
            );
            dispatch(
                getWebMatrixPatientCount({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                }),
            );
            dispatch(
                getEngagementRateDataFalse({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    trigger_name: '',
                }),
            );

            dispatch(
                getWebMatrixCostDataFalse({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                }),
            );
        }
    }, [company, startDateRange, endDateRange]);

    return (
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {config.showComponents.digitalEngagementInfo && (
                    <Grid item xs={12}>
                        <DigitalEngagementInfo />
                    </Grid>
                )}
                {config.showComponents.webMetricsInfo && (
                    <Grid item xs={12}>
                        <WebMetricsInfo />
                    </Grid>
                )}
                {config.showComponents.engagementSegments && (
                    <Grid item xs={6}>
                        <EngagementChannel />
                    </Grid>
                )}
                {config.showComponents.ctrChart && (
                    <Grid item xs={6}>
                        <CtrChart />
                    </Grid>
                )}
                {config.showComponents.costChart && (
                    <Grid item xs={6}>
                        <CostChart />
                    </Grid>
                )}
                {config.showComponents.deviceEngagement && (
                    <Grid item xs={6}>
                        <DeviceEngagement />
                    </Grid>
                )}
                {config.showComponents.ageEngagement && (
                    <Grid item xs={6}>
                        <AgeEngagement />
                    </Grid>
                )}
                {config.showComponents.genderEngagement && (
                    <Grid item xs={6}>
                        <GenderEngagement />
                    </Grid>
                )}
                {config.showComponents.cityBreakdown && (
                    <Grid item xs={12}>
                        <CityBreakdown />
                    </Grid>
                )}

                {config.showComponents.dtcTopCityChart && (
                    <Grid item xs={6}>
                        <DtcTopCityChart />
                    </Grid>
                )}

                {config.showComponents.dtcTopChannelChart && (
                    <Grid item xs={6}>
                        <DtcTopChannelChart />
                    </Grid>
                )}

                {config.showComponents.powerBi && (
                    <Grid item className="mt-3 mb-3" xs={12}>
                        <PowerBi />
                    </Grid>
                )}

                {config.showComponents.searchUsingFilter && (
                    <Grid item xs={12}>
                        <SearchUsingFilter />
                    </Grid>
                )}

                {config.showComponents.npiTable && (
                    <Grid item sx={{ minWidth: 0 }} xs={12}>
                        <NPITable />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

export default PaidMediaEngagement;
